/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Representation of a Feature Value
 * @export
 * @interface FeatureValue
 */
export interface FeatureValue {
    /**
     * Value of the feature
     * @type {string}
     * @memberof FeatureValue
     */
    value?: string;
}

/**
 * Check if a given object implements the FeatureValue interface.
 */
export function instanceOfFeatureValue(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FeatureValueFromJSON(json: any): FeatureValue {
    return FeatureValueFromJSONTyped(json, false);
}

export function FeatureValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeatureValue {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function FeatureValueToJSON(value?: FeatureValue | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
    };
}

